import { Map } from 'immutable';
import { v4 } from 'uuid';

import { shapeCollections, shapeLinkedShops, shapeSection } from '../listings/listings';

import { ETSY, FAIRE, SHOPIFY } from '../../constants/channels';
import { NEW, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { LISTING } from '../../constants/listings';
import { FORM } from '../../constants/forms';
import { VELA } from '../../constants';

const { DETAILS, INVENTORY } = FORM;

export function shapeForTable({ product: source, shopData, shopIds, userShops }) {
  const id = source.get('productId');
  const channel = source.get('channel');
  const isPlaceholderForNewProduct = id === NEW;
  let product = Map({
    isPlaceholderForNewProduct,
    [LISTING[VELA].PHOTO]: source.getIn([ATTRIBUTE.PHOTOS, VALUE, 0, 'fullsize_url']),
    [LISTING[VELA].PRICE]: source.getIn([INVENTORY, ATTRIBUTE.PRICE, VALUE]),
    [LISTING[VELA].PRODUCT_ID]: isPlaceholderForNewProduct ? v4() : id,
    [LISTING[VELA].QUANTITY]: source.getIn([INVENTORY, ATTRIBUTE.QUANTITY, VALUE]),
    [LISTING[VELA].TITLE]: source.getIn([ATTRIBUTE.TITLE, VALUE]),
  });

  const { linkedProductsShopIds, linkedProductsShopChannels } = shapeLinkedShops({ shopIds, userShops });

  product = product
    .set(LISTING[VELA].LINKED_PRODUCTS_SHOP_IDS, linkedProductsShopIds)
    .set(LISTING[VELA].LINKED_PRODUCTS_SHOP_CHANNELS, linkedProductsShopChannels);

  switch (channel) {
    case ETSY: {
      const section = source.getIn([DETAILS, ATTRIBUTE.SECTION, VALUE]);
      product = product.set(LISTING[VELA].SECTION, shapeSection({ section, shopData }));
      break;
    }

    case FAIRE: {
      const retailPrice = source.getIn([INVENTORY, ATTRIBUTE.RETAIL_PRICE, VALUE]);
      product = product.set(LISTING[VELA].PRICE, retailPrice);
      break;
    }

    case SHOPIFY: {
      const collections = source.getIn([DETAILS, ATTRIBUTE.COLLECTIONS, VALUE]);
      product = product.set(LISTING[VELA].COLLECTIONS, shapeCollections({ collections, shopData }));
      break;
    }

    default: {
      break;
    }
  }

  return product;
}
